<template>
    <page-container2 :title="formTitle" :useCard="false" showPageBack>
        <template v-slot:buttons >
            <el-button type="primary" size="mini" v-on:click="downloadBill" >下载</el-button>
            <!--<el-button type="warning" size="mini" v-on:click="reGenrateBill" >重新生产当月账单</el-button>-->
            <el-button type="success" size="mini" @click="loadCustomerBill" :disabled="!customerBill.id">刷新</el-button>
        </template>
        <permission-container  v-loading="loading" showTip permissionId="Erp.CustomerBill.Detail">
            <el-form ref="orderForm" :model="customerBill" v-loading="loading" status-icon :inline-message="true" label-width="0px" size="mini">
                <el-card id="printInfo">
                    <div class="panel-info">
                        <div class="panel-info-name">
                            <span class="panel-info-label">账单信息</span>
                        </div>
                        <div class="panel-table">
                            <el-row class="panel-table-row">
                                <el-col :span="3"><span class="panel-table-col col-label required">客户：</span></el-col>
                                <el-col :span="3">
                                    <div class="panel-table-col col-input">{{ customerBill.customerName }}</div>
                                </el-col>
                                <el-col :span="3"><span class="panel-table-col col-label required">客户编号：</span></el-col>
                                <el-col :span="3">
                                    <div class="panel-table-col col-input">{{ customerBill.customerCode }}</div>
                                </el-col>
                                <el-col :span="3"><span class="panel-table-col col-label required">月份：</span></el-col>
                                <el-col :span="3">
                                    <div class="panel-table-col col-input">{{customerBill.month}}</div>
                                </el-col>
                                <el-col :span="3"><span class="panel-table-col col-label required">账单周期：</span></el-col>
                                <el-col :span="3">
                                    <div class="panel-table-col col-input"><date-render :value="customerBill.billStartDate"/> 至 <date-render :value="customerBill.billEndDate"/></div>
                                </el-col>
                            </el-row>
                        </div>
                        
                    </div>

                    <div class="panel-info">
                        <div class="panel-info-name">
                            <span class="panel-info-label">订单</span>
                        </div>
                        <div class="panel-table">
                            <el-row class="panel-table-row">
                                <el-col :span="2"><span class="panel-table-col col-header">发货日期</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header">送货单号</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header">客户订单号</span></el-col>
                                <el-col :span="4"><span class="panel-table-col col-header">货物名称</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header">规格</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header">数量</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header">重量（KG）</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header">单价</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header">金额(RMB)</span></el-col>
                                <el-col :span="4"><span class="panel-table-col col-header">备注</span></el-col>
                            </el-row>
                            <template v-for="(billItem, index) in billItemList" v-if="billItem.itemType==1">
                                <el-row class="panel-table-row">
                                    <el-col :span="2">
                                        <span class="panel-table-col col-input">
                                            <date-render :value="billItem.deliverDate"></date-render>
                                        </span>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input">
                                            {{billItem.deliveryNumber}}
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input">
                                            {{billItem.customerOrderCode}}
                                        </div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="panel-table-col col-input">
                                            {{billItem.productName}}
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input" style="justify-content: center;">
                                            {{billItem.spec}}
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input" style="justify-content: right;">
                                            {{billItem.num}}
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input" style="justify-content: right;">
                                            {{ billItem.itemType == 2? '-':'' }}{{billItem.unitNum}}
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input" style="justify-content: right;">
                                            <money-render :value="billItem.unitPrice" :precision="4"></money-render>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input" style="justify-content: right;">
                                            {{ billItem.itemType == 2? '-':'' }}
                                            <money-render :value="billItem.amount" :precision="2"></money-render>
                                        </div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="panel-table-col col-input">
                                            {{billItem.remark}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </template>
                        </div>
                    </div>
                    <div class="panel-info">
                        <div class="panel-info-name">
                            <span class="panel-info-label">售后单</span>
                        </div>
                        <div class="panel-table">
                            <el-row class="panel-table-row">
                                <el-col :span="2"><span class="panel-table-col col-header">退货日期</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header">退货单号</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header"></span></el-col>
                                <el-col :span="4"><span class="panel-table-col col-header">货物名称</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header">规格</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header">数量</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header">重量（KG）</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header">单价</span></el-col>
                                <el-col :span="2"><span class="panel-table-col col-header">金额(RMB)</span></el-col>
                                <el-col :span="4"><span class="panel-table-col col-header">备注</span></el-col>
                            </el-row>
                            <template v-for="(billItem, index) in billItemList" v-if="billItem.itemType==2">
                                <el-row class="panel-table-row">
                                    <el-col :span="2">
                                        <span class="panel-table-col col-input">
                                            <date-render :value="billItem.returnDate"></date-render>
                                        </span>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input">
                                            {{billItem.afterSaleCode}}
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input">
                                            -
                                        </div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="panel-table-col col-input">
                                            {{billItem.productName}}
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input" style="justify-content: center;">
                                            {{billItem.spec}}
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input" style="justify-content: right;">
                                            {{billItem.num}}
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input" style="justify-content: right;">
                                            {{ billItem.itemType == 2? '-':'' }}{{billItem.unitNum}}
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input" style="justify-content: right;">
                                            <money-render :value="billItem.unitPrice" :precision="4"></money-render>
                                        </div>
                                    </el-col>
                                    <el-col :span="2">
                                        <div class="panel-table-col col-input" style="justify-content: right;">
                                            {{ billItem.itemType == 2? '-':'' }}
                                            <money-render :value="billItem.amount" :precision="2"></money-render>
                                        </div>
                                    </el-col>
                                    <el-col :span="4">
                                        <div class="panel-table-col col-input">
                                            {{billItem.remark}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </template>
                        </div>
                    </div>
                    <div class="panel-info" style="margin-top: -10px;">
                        <div class="total-price">
                            <el-row class="">
                                <el-col :span="14">总计：</el-col>
                                <el-col :span="2">
                                    <div class="panel-table-col col-input" style="text-align: right;">
                                        <money-render :value="customerBill.totalUnitNum"></money-render>
                                    </div>
                                </el-col>
                                <el-col :span="2">
                                    <div class="panel-table-col col-input" style="text-align: right;">
                                        &nbsp;
                                    </div>
                                </el-col>
                                <el-col :span="2">
                                    <div class="panel-table-col col-input" style="text-align: right;">
                                        <money-render :value="customerBill.totalAmount"></money-render>
                                    </div>
                                </el-col>
                                <el-col :span="4"><span class="panel-table-col col-header"></span></el-col>
                            </el-row>
                        </div>
                    </div>
                </el-card>
            </el-form>
        </permission-container>
    </page-container2>
</template>

<script>
import XLSXS from 'xlsx-js-style'

export default {
    name: "CustomerBillDetail",
    data()
    {
        return {
            loading: false,
            formTitle: '对账单详情',
            permissionId: 'Erp.CustomerBill.Detail',
            customerBill: {
                id: null,
                customerId: null,
                customerCode: '',
                customerName: '',
                month: '',
                billStartDate: '',
                billEndDate: '',
                orderNum: null,
                afterSaleNum: null,
                totalUnitNum: null,
                totalAmount: null
            },
            billItemList:[]
        }
    },
    mounted()
    {
        return Fx.Promise.
        then(()=>
        {
            if(this.$route.query && this.$route.query.id)
            {
                this.customerBill.id = this.$route.query.id;
                return this.loadCustomerBill();
            }
        })
    },
    methods:
    {
        loadCustomerBill()
        {
            this.loading = true;
            return Fx.Http.post("/stats/customerBill/get", {id: this.customerBill.id}).
            then((resp)=>
            {
                console.log('customerBill:', resp);
                if(resp.isSuccess())
                {
                    this.customerBill = Fx.mergeDeep(this.customerBill, resp.getData());
                    this.billItemList = resp.getData('billItemList');
                }
            }).
            then(()=>
            {
                this.loading = false;
            });
        },
        downloadBill(){
            this.loading = true;
            let loadingTip = this.showMessageWarning('下载中...')
            /* 定义表头
                定义表头，每一行即是一个数组，数组中的元素即是一个个单元格内容。
                如果单元格不需要样式，那么每个元素类型为字符串即可。如：['一月（2022年01月）'], 
                如果单元格需要样式，那么数组中的元素就需要为一个个对象，在此对象中定义单元格的样式等等。
                这里只针对第一行进行举例：
            */
           
            let cellStyle = {
                font: {
                    bold: false,
                    sz: 10,
                    name: '宋体',
                },
                border:{ top: {style:'thin',color:'black'}, left: {style:'thin',color:'black'}, right: {style:'thin',color:'black'}, bottom: {style:'thin',color:'black'}},
                alignment:{
                    wrapText: true,
                    vertical: 'center', // 垂直居中
                    horizontal: 'center', // 水平居中
                }
            };
            const header = [
            [
                {
                v: '深圳市利弘昇新材料有限公司',
                t: 's',
                s: {
                    // font 字体属性
                    font: {
                        bold: true,
                        sz: 20,
                        name: '宋体',
                    },
                    // alignment 对齐方式
                    alignment: {
                        vertical: 'center', // 垂直居中
                        horizontal: 'center', // 水平居中
                    },
                },
                },
            ],
            [
                {
                v: '地址:深圳市龙岗区龙岗街道五联社区将军帽小区38号D栋101',
                t: 's',
                s: {
                    // font 字体属性
                    font: {
                        bold: false,
                        sz: 11,
                        name: '宋体',
                    },
                    // alignment 对齐方式
                    alignment: {
                        vertical: 'center', // 垂直居中
                        horizontal: 'center', // 水平居中
                    },
                },
                },
            ],
            [
                {
                v: '电话:0755-84514556  传真:0755-84514963',
                t: 's',
                s: {
                    // font 字体属性
                    font: {
                        bold: false,
                        sz: 11,
                        name: '宋体',
                    },
                    // alignment 对齐方式
                    alignment: {
                        vertical: 'center', // 垂直居中
                        horizontal: 'center', // 水平居中
                    },
                },
                },
            ],
            [
                {
                v: this.moment(this.customerBill.month).format('YYYY年MM月') + '对账单',
                t: 's',
                s: {
                    // font 字体属性
                    font: {
                        bold: true,
                        sz: 18,
                        name: '宋体',
                    },
                    // alignment 对齐方式
                    alignment: {
                        vertical: 'center', // 垂直居中
                        horizontal: 'center', // 水平居中
                    }
                },
                },
            ],
            [
                {
                v: '客户名称：'+this.customerBill.customerName,
                t: 's',
                s: {
                    // font 字体属性
                    font: {
                        bold: false,
                        sz: 12,
                        name: '宋体',
                    },
                    // alignment 对齐方式
                    alignment: {
                        vertical: 'center', // 垂直居中
                        horizontal: 'left', // 水平居中
                    }
                },
                },
            ],
            [{v:'发货日期',s: cellStyle}, {v:'送货单号',s: cellStyle}, {v:'客户订单号',s: cellStyle}, {v:'货物名称',s: cellStyle}, {v:'规格',s: cellStyle},
                 {v:'支数',s: cellStyle}, {v:'重量（KG）',s: cellStyle},{v:'单价',s: cellStyle},{v:'金额（RMB）',s: cellStyle},{v:'备注',s: cellStyle}],
            ]
            // 需要导出的数据源
            let body = [];
            body.push(...header);
            const rows = [ { hpx: 33 },{ hpx: 15 },{ hpx: 15 },{ hpx: 23 },{ hpx: 33 },{ hpx: 25 }]
            for (let billItem of this.billItemList) {
                if(billItem.itemType == 1) { // 订单
                    body.push([{v:this.moment(billItem.deliverDate).format('YYYY/MM/DD'), s: cellStyle},{v:`${billItem.deliveryNumber}`, s: cellStyle},{v:`${billItem.customerOrderCode}`, s: cellStyle}
                    ,{v:`${billItem.productName}`, s: cellStyle},{v:`${billItem.spec}`, s: cellStyle},{v: billItem.num, t: 'n', s: cellStyle}
                    ,{v: billItem.unitNum, t: 'n', s: cellStyle},{v:`${billItem.unitPrice}`, s: cellStyle},
                    {v: billItem.amount.toFixed(2), t: 'n', s: cellStyle},{v:`${billItem.remark}`, s: cellStyle}]);
                } else if(billItem.itemType == 2) { //  售后单
                    body.push([{v:this.moment(billItem.returnDate).format('YYYY/MM/DD'), s: cellStyle},{v:`${billItem.afterSaleCode}`, s: cellStyle},{v:``, s: cellStyle}
                    ,{v:`${billItem.productName}`, s: cellStyle},{v:`${billItem.spec}`, s: cellStyle},{v: billItem.num, t: 'n', s: cellStyle}
                    ,{v: 0 - billItem.unitNum, t: 'n', s: cellStyle},{v:`${billItem.unitPrice}`, s: cellStyle},
                    {v:(0 - billItem.amount).toFixed(2), t: 'n', s: cellStyle},{v:`${billItem.remark}`, s: cellStyle}]);
                }
                rows.push({ hpx: 20 });
            }
            body.push([{v:'合计', s: cellStyle},{v:'', s: cellStyle},{v:'', s: cellStyle},{v:'', s: cellStyle},{v:'', s: cellStyle},{v:'', s: cellStyle}
                ,{f:`SUM(G7:G${6+this.billItemList.length})`, s: Fx.mergeDeep(cellStyle,{font: {bold: true}})},
                {v:'', s: cellStyle},{f:`SUM(I7:I${6+this.billItemList.length})`, s: Fx.mergeDeep(cellStyle,{font: {bold: true}})},{v:'', s: cellStyle}]);
            rows.push({ hpx: 20 });
            body.push([
                {
                v: '敬请确认后签盖回传，若七天内没回签，我司将视同默认。传真件与原件具有同等效力。',
                t: 's',
                s: {
                    // font 字体属性
                    font: {
                        bold: true,
                        sz: 12,
                        name: '宋体',
                    },
                    // alignment 对齐方式
                    alignment: {
                        vertical: 'center', // 垂直居中
                        horizontal: 'left', // 水平居中
                    },
                },
                },
            ])
            rows.push({ hpx: 45 });
            body.push([
                {
                v: '客户确认（签名及盖章）：',
                t: 's',
                s: {
                    // font 字体属性
                    font: {
                        bold: false,
                        sz: 12,
                        name: '宋体',
                    },
                    // alignment 对齐方式
                    alignment: {
                        vertical: 'center', // 垂直居中
                        horizontal: 'center', // 水平居中
                    },
                },
                },
            ])
            rows.push({ hpx: 15 });
                // 将数据源转成我们需要的二维数组
            // const body = data.map(x => ([x.name, x.mb_num, x.mb_sum, x.pc_num, x.pc_sum, x.total_num, x.total_sum]))    
            // body.unshift(...header);// 将定义好的表头添加到 body 中
            
            const sheet = XLSXS.utils.aoa_to_sheet(body);// aoa_to_sheet 将二维数组转成 sheet

            // 设置合并单元格
            const merges = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 9 } },
            { s: { r: 1, c: 0 }, e: { r: 1, c: 9 } },
            { s: { r: 2, c: 0 }, e: { r: 2, c: 9 } },
            { s: { r: 3, c: 0 }, e: { r: 3, c: 9 } },
            { s: { r: 4, c: 0 }, e: { r: 4, c: 9 } },
            { s: { r: 4+this.billItemList.length+3, c: 0 }, e: { r: 4+this.billItemList.length+3, c: 9 } },
            { s: { r: 4+this.billItemList.length+4, c: 0 }, e: { r: 4+this.billItemList.length+4, c: 9 } },
            ]
            sheet['!merges'] = merges; // 将merges添加到sheet中

            // 设置列宽
            const cols = [ { wch: 10 },{ wch: 15 },{ wch: 10 },{ wch: 19 },{ wch: 13 },{ wch: 8 },{ wch: 10 },{ wch: 8 },{ wch: 12 },{ wch: 18 } ];
            sheet['!cols'] = cols; // 将cols添加到sheet中

            // 
            
            sheet['!rows'] = rows; // 将rows添加到sheet中，设置行高

            const workbook = XLSXS.utils.book_new();// 创建虚拟的 workbook
            XLSXS.utils.book_append_sheet(workbook, sheet, this.moment(this.customerBill.month).format('YYYY年MM月') + '对账单'); // 向 workbook 中添加 sheet
            XLSXS.writeFile(workbook, '利弘昇-'+this.customerBill.customerName +this.moment(this.customerBill.month).format('YYYYMM') +  '对账单.xlsx'); // 导出 workbook
            // 注意：定义导出 excel 的名称时需要加上后缀 .xlsx
            setTimeout(()=>{
                this.loading = false;
                loadingTip&&loadingTip.close();
            }, 500)
        },
        reGenrateBill(){
            this.showMessageWarning('功能暂未开发')
        }
        
    },
    computed:
    {
        productTotalAmount()
        {
            let amount = 0.00;
            this.billItemList&&this.billItemList.map(billItem=>amount+=(isNaN(billItem.amount)? 0: billItem.amount));
            return amount;
        },
        productTotalNum()
        {
            let num = 0;
            this.billItemList&&this.billItemList.map(billItem=>num+=(isNaN(billItem.num)? 0: billItem.num));
            return num;
        
        },
        productTotalUnitNum()
        {
            let unitNum = 0;
            this.billItemList&&this.billItemList.map(billItem=>unitNum+=(isNaN(billItem.unitNum)? 0: billItem.unitNum));
            return unitNum;
        }
    }
}
</script>

<style scoped lang="scss">
@import "~@/styles/common.scss";
.order-panel
{
    flex:1;
    max-width: calc(100% - 300px);
}
.order-state-caption
{
    padding: 5px 20px;
    background-color: #ff8e02;
    color: white;
    font-size: 18px;
}
.exchange-rate
{
    color: #333333;
    font-size: 12px;
    margin-bottom: 3px;
}
.total-price
{
    font-size: 14px;
    font-weight: 700;
}
.dialog-message
{
    color: rgb(255, 153, 0);
    margin: 0 0 10px 31px;
}
.demo-order
{
    padding: 1px 5px;
    margin-left: 3px;
    border-radius: 3px;
    color: #ffffff;
    background-color: #ff8e02;
}

</style>



// WEBPACK FOOTER //
// src/modules/erp/pages/statement/CustomerBillDetail.vue